// extracted by mini-css-extract-plugin
export var active = "_1v-7";
export var container = "_1v-0";
export var evenWidth = "_1v-4";
export var large = "_1v-5";
export var outlet = "_1v-8";
export var slide = "_1v-2";
export var small = "_1v-6";
export var tab = "_1v-3";
export var tabs = "_1v-1";